import React, { useState } from 'react';
import { Mui, MuiStyles } from '@osu/react-ui';
import useActionMenuItems from './useActionMenuItems';

// The menu is driven by a menu-items hook so the same button/menu shell can serve both the Honors
// applicant page (default useActionMenuItems) and the Scholars page (useScholarsActionMenuItems),
// mirroring the same Actions pattern without duplicating the shell.

const createClasses = (theme) => {
    return {
        icon: {
            display: 'flex',
            alignItems: 'center',
            marginRight: '1rem',
            color: theme.palette.primary.main,
        },
        menuItem: {
            padding: '.7rem 1rem .7rem 1rem',
            borderLeft: `4px solid white`,
            fontSize: "1.085em",
            '&:hover': {
                borderLeft: `4px solid ${theme.palette.primary.main}`,
            },
            minWidth: '16rem',
        },
        muiList: {
            '& .MuiMenu-list': {
                // paddingTop: 0,
                // paddingBottom: 0,
                minWwidth: '15rem',
            },
        },
    };
};

// Default to be used if no dialog component defined in menuItems.js
function EmptyDialogComponent() { return <></>; }

export default function ActionsButtonAndPopupMenu({ useMenuItems = useActionMenuItems, hideOnViewPath = true }) {
    const classes = createClasses(MuiStyles.useTheme());
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuItemClicked, setMenuItemClicked] = useState(null);
    const handleClick = (event) => { setMenuAnchorEl(event.currentTarget); };
    const handleClose = () => { setMenuAnchorEl(null); };
    
    const { menuItems = [] } = useMenuItems();
    if (hideOnViewPath && window.location?.pathname?.includes("view")) { return <></>; }
    // Hide the Actions button entirely when the caller has no available actions (e.g. a non-admin on the
    // Scholars page, where the only item is admin-gated). Previously the button rendered but disabled;
    // hiding it avoids showing a dead control to users who can never act.
    if (menuItems.length === 0) { return <></>; }

    const DialogComponent = menuItemClicked?.component ?? EmptyDialogComponent;

    return (
        <React.Fragment>
            <Mui.Button variant="contained" color="primary" onClick={handleClick}>Actions</Mui.Button>
            
            <Mui.Menu id="applicant-menu" sx={classes.muiList} anchorEl={menuAnchorEl} keepMounted open={Boolean(menuAnchorEl)} onClose={handleClose}>
                {
                    menuItems.map((menuItem, index) => {
                        const clickIt = () => { setMenuItemClicked(menuItem); handleClose(); };
                        function fixTabNavigation(event) {
                            if (event.key !== "Tab") { return; }
                            event.preventDefault();
                            event.stopPropagation();
                            
                            const children = Array.from(event.target.parentNode.children);
                            const currentIndex = children.findIndex(ele => ele === event.target);
                            const newIndex = (currentIndex + 1) % children.length;
                            children[newIndex].focus();
                        }
                        
                        return (
                            <Mui.MenuItem key={`${menuItem.type}-${index}`} onClick={clickIt} onKeyDown={fixTabNavigation} sx={classes.menuItem} tabindex="0">
                                <Mui.Box sx={classes.icon}>{menuItem.icon}</Mui.Box>
                                
                                <Mui.Box>{menuItem.label}</Mui.Box>
                            </Mui.MenuItem>
                        );
                    })
                }
            </Mui.Menu>
            
            <DialogComponent menuItemAndClose={{ menuItem: menuItemClicked, close: () => setMenuItemClicked(null), }} />
        </React.Fragment>
    );
}